export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center w-full overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>热门推荐 · 每日更新</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight mb-5">
              春色影视
              <span className="block text-primary-500 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">
                高清免费在线观影平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-body leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              海量影视，流畅不卡顿，完全免费。春色影视汇聚全球热门电影、电视剧、动漫与纪录片，高清画质搭配智能加速技术，让每一次观影都成为享受。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-primary-500">20,000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-primary-500">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-primary-500">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">播放成功率</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-base rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-800 font-medium text-base rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer no-underline border border-background-300/60"
              >
                <i className="ri-movie-line text-lg"></i>
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20atmosphere%20with%20floating%20film%20strips%20and%20movie%20posters%20in%20golden%20light%2C%20elegant%20dark%20theater%20curtains%2C%20soft%20spotlight%20effects%2C%20rich%20amber%20and%20deep%20crimson%20tones%2C%20dreamy%20bokeh%20background%2C%20professional%20movie%20industry%20aesthetic%2C%20artistic%20abstract%20cinema%20composition&width=900&height=675&seq=hero-main&orientation=landscape"
                alt="春色影视 - 高清免费在线观影平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}